const { trackMetric } = require('../collector');
const { WINDOW_HEIGHT, WINDOW_WIDTH } = require('../../constants/metrics');

const windowInformationMonitor = () => {
  const { innerWidth, innerHeight } = window;

  if (innerWidth) {
    trackMetric(WINDOW_WIDTH, `${innerWidth}`);
  }

  if (innerHeight) {
    trackMetric(WINDOW_HEIGHT, `${innerHeight}`);
  }
};

module.exports = windowInformationMonitor;
